"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Platform = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Platform"));
var _StyleSheet = _interopRequireDefault(require("react-native-web/dist/cjs/exports/StyleSheet"));
var _View = _interopRequireDefault(require("react-native-web/dist/cjs/exports/View"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ThemeProvider = require("../ThemeProvider");
var _utils = require("../utils");
var _Icon = _interopRequireDefault(require("../Icon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const [selectProps, selectedSystemPropTypes] = (0, _utils.selectSystemProps)([_utils.a11yProps, _utils.viewProps]);
const selectContainerStyles = _ref => {
  let {
    backgroundColor,
    backgroundGradient,
    borderColor,
    borderRadius,
    borderWidth,
    paddingBottom,
    paddingLeft,
    paddingRight,
    paddingTop
  } = _ref;
  const styles = {
    borderColor,
    borderRadius,
    borderWidth,
    paddingBottom,
    paddingLeft,
    paddingRight,
    paddingTop
  };
  if (backgroundGradient) {
    if (_Platform.default.OS === 'web') {
      styles.background = (0, _utils.transformGradient)(backgroundGradient);
    } else {
      const {
        stops: [stopOne, stopTwo]
      } = backgroundGradient;
      styles.gradient = {};
      styles.gradient.start = {
        x: 0,
        y: 0
      };
      styles.gradient.end = {
        x: 1,
        y: 1
      };
      styles.gradient.colors = [stopOne.color, stopTwo.color];
    }
  } else {
    styles.backgroundColor = backgroundColor;
  }
  return styles;
};
const selectIconProps = _ref2 => {
  let {
    icon,
    iconColor,
    iconSize,
    iconPaddingTop
  } = _ref2;
  return {
    icon,
    tokens: {
      color: iconColor,
      paddingTop: iconPaddingTop,
      size: iconSize
    },
    variant: {
      size: 'small'
    }
  };
};
const selectTextStyles = _ref3 => {
  let {
    textColor,
    textLineHeight,
    fontName,
    fontSize,
    fontWeight,
    marginLeft
  } = _ref3;
  return (0, _ThemeProvider.applyTextStyles)({
    fontColor: textColor,
    fontName,
    fontSize,
    fontWeight,
    lineHeight: _Platform.default.OS === 'web' ? textLineHeight : textLineHeight * 1.2,
    marginLeft
  });
};

/**
 * Status component displays a status indicator with optional custom gradient.
 *
 * @component
 * @param {object} tokens - The tokens for customizing the status component.
 * @param {string} variant - The variant of the status component.
 * @param {ReactNode} children - The content to be displayed inside the status component.
 * @param {function} customGradient - The custom gradient function for the status component.
 * @param {elementType} customGradient - Defines an icon to be rendered.
 * @param {object} rest - The rest of the props to be applied to the status component.
 * @param {React.Ref} ref - The ref to be applied to the status component.
 * @returns {ReactNode} The rendered status component.
 */
const Status = /*#__PURE__*/_react.default.forwardRef((_ref4, ref) => {
  let {
    tokens,
    variant,
    children,
    customGradient,
    ...rest
  } = _ref4;
  const themeTokens = (0, _ThemeProvider.useThemeTokens)('Status', tokens, variant);
  const {
    icon
  } = themeTokens;
  const containerStyles = {
    ...selectContainerStyles(themeTokens),
    ...staticStyles.container
  };
  let content = /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [icon ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
      ...selectIconProps(themeTokens)
    }) : null, (0, _utils.wrapStringsInText)(children, {
      style: selectTextStyles(themeTokens)
    })]
  });
  if (typeof customGradient === 'function') {
    content = customGradient(containerStyles.gradient, containerStyles, content);
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
    ref: ref,
    style: containerStyles,
    ...selectProps(rest),
    children: content
  });
});
Status.displayName = 'Status';
Status.propTypes = {
  ...selectedSystemPropTypes,
  tokens: (0, _utils.getTokensPropType)('Status'),
  variant: _utils.variantProp.propType,
  /**
   * The content to be displayed inside the status component.
   */
  children: _propTypes.default.node.isRequired,
  /**
   * The custom gradient function for the status component.
   */
  customGradient: _propTypes.default.func
};
const staticStyles = _StyleSheet.default.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    ..._Platform.default.select({
      web: {
        display: 'inline-flex',
        width: 'fit-content'
      },
      default: {
        display: 'flex',
        width: 'auto'
      }
    })
  }
});
var _default = exports.default = Status;